import { Line, MultilineInput } from "@tblabs/truffle";
import { Step } from "../Step/Step";
import { Cash } from "../Step/Cash";
import { StepEvent, StepEventType } from "../Step/StepEvent";
import moment from "moment";
import { StepType } from "../Step/StepType";
import { ToDo } from "../../Components/ToDo";
import { AddToBasketStepState } from "./Models/AddToBasketStepState";
import { AddToBasketStepData } from "./Models/AddToBasketStepData";
import { BasketPreview } from "./Components/BasketPreview";
import { DateTimeProvider } from "../../Services/DateTimeProvider";
import { CashType } from "../Step/CashType";


export class AddToBasketStep extends Step<AddToBasketStepState>
{
    public Type = StepType.AddToBasket;
    public Icon = "🛒";
    public TitleForCustomer = () => `Zamówienie`;
    public Title = () => this.Order?.ShortId ? `Zamówienie #${this.Order?.ShortId}` : `Uzupełnienie koszyka`;

    public InitialState = AddToBasketStepState.New;
    public WellDoneStates = [AddToBasketStepState.Accepted];
    public FailedDoneStates = [AddToBasketStepState.Rejected];

    public get AsEvents(): StepEvent[]
    {
        return [
            new StepEvent(StepEventType.AddToBasket, this.Order.Id, "🛒", "Utworzenie zamówienia", this.Data.CreatedAt, this.IsDone)
        ];
    }

    public get Mana(): Cash[]
    {
        return [
            new Cash(CashType.BasketValue, this, this.Order.BasketValue, "Wartość koszyka", this.Data.CreatedAt),
            new Cash(CashType.DesiredDeposit, this, this.Order.DesiredDeposit, "Planowana kaucja", this.Data.CreatedAt),
        ];
    }

    public get WhenPlanned(): Date
    {
        return this.Data.CreatedAt;
    }

    public get WhenDone(): Date
    {
        return this.Data.AcceptedTime.value;
    }

    constructor(public Data: AddToBasketStepData)
    {
        super(Data);

        this.Data.SearchBy = this.Data.BasketItems.Items.map(x => x.ProductSerialNumber.value).join(" ");
    }

    public STATES = {
        [AddToBasketStepState.New]: {
            StateName: "Jeszcze nie zaakceptowane",
            Timeout: () => moment(this.Data.CreatedAt).add(1, "day").toDate(),
            Customer: {
                Content: () => [
                    new BasketPreview(this.Data.BasketItems),
                    new Line(),
                    `☑️ Stan magazynowy wskazuje na dostępność produktów, ale dla pewności potwierdzi to jeszcze ktoś z naszej obsługi`],
            },
            Admin: {
                Content: () => [
                    new BasketPreview(this.Data.BasketItems),
                    new Line(),
                    this.Order.PeopleAsString,
                    new Line(),
                    new ToDo(`Potwierdź lub odrzuć to zamówienie uwzględnając dostępność sprzętu w danym terminie`)],
                Actions: {
                    "✅": () => { this.Data.AcceptedTime.value = DateTimeProvider.Now; this.GoTo(AddToBasketStepState.Accepted); },
                    "❌": () => this.GoTo(AddToBasketStepState.Rejecting),
                },
            },
        },
        [AddToBasketStepState.Accepted]: {
            StateName: "Zaakceptowane",
            Customer: {
                Content: () => [
                    `✅ Zamówienie zostało zaakceptowane`,
                    new BasketPreview(this.Data.BasketItems),
                ],
            },
            Admin: {
                Content: () => [
                    `✅ Zamówienie zostało zaakceptowane`,
                    new BasketPreview(this.Data.BasketItems),
                ],
            },
        },
        [AddToBasketStepState.Rejecting]: {
            StateName: "Odrzucanie w toku",
            Customer: {
                Content: () => [new BasketPreview(this.Data.BasketItems)],
            },
            Admin: {
                Content: () => ["Powód odrzucenia (widoczne dla klienta!):",
                    new MultilineInput(this.Data.RejectionReason).Rows(4)],
                Actions: {
                    "✔️": () => this.GoTo(AddToBasketStepState.Rejected),
                    "✖️": () => this.GoTo(AddToBasketStepState.New),
                },
            },
        },
        [AddToBasketStepState.Rejected]: {
            StateName: "Odrzucone",
            Customer: {
                Content: () => [
                    new BasketPreview(this.Data.BasketItems).Opacity(0.6), 
                    `❌ Niestety zamówienie zostało odrzucone z powodu: ${this.Data.RejectionReason.value || "(powodu nie podano)"}`
                ],
            },
            Admin: {
                Content: () => [`❌ Zamówienie zostało odrzucone z powodu: ${this.Data.RejectionReason.value || "(powód nie został wpisany)"}`],
            }
        },
    };
}
